import { createContext } from 'react';
import type { CustomerUserInfo } from '../lib/auth';

export type AuthStatus = 'bootstrapping' | 'authenticated' | 'unauthenticated';

export interface AuthContextValue {
  status: AuthStatus;
  user: CustomerUserInfo | null;
}

export const AuthContext = createContext<AuthContextValue>({
  status: 'bootstrapping',
  user: null,
});
